var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"fix-left"},[(_vm.rid)?_c('radishDetail',{attrs:{"id":_vm.rid,"type":"left"}}):_vm._e(),_c('div',{staticClass:"fix-middle-actions"},[_c('el-button',{attrs:{"circle":"","size":"mini","icon":"el-icon-close"},on:{"click":_vm.close}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }